export default "__VITE_ASSET__kZhArdwN__"